import { useNavigate } from "react-router-dom";
import { MenuTop } from '../../../components/menu/top/menu-top';
import IconButtonComponent from '../../../components/Icon/icon-button';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import '../styles/admin-page.css';

export const AdminPage = () => {
    const navigate = useNavigate();
    
    return (
        <div>
            <MenuTop />
            <div className="admin-page-container">
                <h1>Painel Administrativo</h1>
                
                <div className="admin-buttons-container">
                    <IconButtonComponent
                        label="Listar Usuários"
                        icon={<PersonIcon />}
                        onClick={() => navigate('/admin-painel/users')}
                    />

                    <IconButtonComponent
                        label="Listar Configurações"
                        icon={<SettingsIcon />}
                        onClick={() => navigate('/admin-painel/list-configs')}
                    />

                    <IconButtonComponent
                        label="Novo Usuário"
                        icon={<PersonIcon />}
                        onClick={() => navigate('/admin-painel/add-user')}
                    />
                </div>
            </div>
        </div>
    );
}